type TagIntent = "positive" | "warning" | "negative" | "grayscale";

const IMPORT_STATUS_INTENT_MAP: Record<string, TagIntent> = {
  integrated: "positive",
  accepted: "warning",
  matching: "negative",
};
const DEFAULT_INTENT: TagIntent = "grayscale";

export const fromImportStatusToIntent = (importStatus: string): TagIntent => {
  return IMPORT_STATUS_INTENT_MAP[importStatus] || DEFAULT_INTENT;
};
